<template>
  <div class="bracelet-finder__image-gallery">
    <div class="bracelet-finder__modal-close-container">
      <button
        class="bracelet-finder__modal-close icon-button"
        type="button"
        @click.prevent="overlay.close()"
      >
        <span
          class="visually-hidden"
          v-text="$string('accessibility.close')"
        />
        <icon-close />
      </button>
    </div>
    <div class="bracelet-finder__modal-main-image">
      <splide
        ref="braceletModalSplide"
        :options="splideModalOptions"
        :has-track="false"
      >
        <splide-track>
          <template
            v-for="(modalImage, index) of allImages"
            :key="`slide-${index}`"
          >
            <splide-slide>
              <responsive-image
                :image="modalImage"
                min-max="342-1026"
                ratio="1:1"
                sizes="100vw"
              />
            </splide-slide>
          </template>
        </splide-track>
      </splide>
    </div>
    <div class="bracelet-finder__gauge-images">
      <div
        v-for="(modalThumb, index) of allImages"
        :key="`thumb-${index}`"
        class="bracelet-finder__gauge-image-container"
      >
        <div
          class="bracelet-finder__gauge-image"
          @click.prevent="handleModalImageClick(index)"
        >
          <responsive-image
            :image="modalThumb"
            min-max="50-150"
            ratio="1:1"
            sizes="50px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
* Vue: Bracelet finder (bracelet-finder)
* -----------------------------------------------------------------------------
* Bracelet Finder Section based off of meta-object.
*
*
*/

import { mapActions } from 'vuex'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

import ResponsiveImage from '~global/images/responsive-image'
import IconClose from '~icons/directional-navigation/close.svg'

export default {
  name: 'BraceletFinderMobileGallery',

  components: {
    Splide,
    SplideSlide,
    SplideTrack,
    IconClose,
    ResponsiveImage,
  },

  props: {
    overlay: {
      type: Object,
      default: () => ({}),
    },
    currentImageIndex: {
      type: Number,
      default: 0,
    },
    allImages: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      splideModalOptions: {
        mediaQuery: 'max',
        focus: 'center',
        wheel: false,
        arrows: false,
        drag: false,
        flickPower: 200,
        perPage: 1,
        pagination: false,
        type: 'fade',
        omitEnd: false,
        autoplay: false,
        keyboard: false,
        trimSpace: true,
        start: this.currentImageIndex,
        easing: 'ease',
        speed: 700,
      },
    }
  },

  methods: {

    /**
 * Map Vuex actions.
 */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    handleModalImageClick(newIndex) {
      this.$refs.braceletModalSplide.go(newIndex)
    },
  },
}
</script>

    <style lang="scss">
      @import './bracelet-finder';
    </style>
